import type { JobJson } from 'bullmq';
import React from 'react';

import { nodeTaskApi } from '~/client/services';

interface Props {
  jobId: string;
  pollingInterval?: number;
  onComplete?: (data: JobJson) => void;
}

const ShowProgress: React.FC<Props> = ({
  jobId,
  pollingInterval,
  onComplete,
}) => {
  const [taskActive, setTaskActive] = React.useState(true);
  const onCompleteRef = React.useRef(onComplete);

  // Keep ref updated
  React.useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const { data } = nodeTaskApi.useStatusQuery(jobId, {
    pollingInterval: taskActive ? pollingInterval : undefined,
    skip: !taskActive,
  });
  const [cancelTask] = nodeTaskApi.useCancelMutation();

  // Use useMemo to derive task completion state without triggering effects
  const isComplete = React.useMemo(() => {
    if (data) {
      const { job, state } = data;
      if (state === 'completed' || state === 'failed') {
        // Call onComplete callback directly in useMemo
        // This is safe because it's a side-effect we want when data changes
        if (taskActive) {
          setTaskActive(false);
          onCompleteRef.current?.(job);
        }
        return true;
      }
    }
    return false;
  }, [data, taskActive]);

  if (!taskActive) {
    return null;
  }

  return (
    <div>
      <div>Task Running...</div>
      <pre>{JSON.stringify(data, null, 2)}</pre>
      <p />
      <button
        onClick={() => {
          cancelTask(jobId);
        }}
      >
        Cancel Task
      </button>
      <p />
    </div>
  );
};

export default ShowProgress;
